<template>
  <div id="app">Math Wallet</div>
</template>

<script>
import { Blockchains, ReqeustActions } from "./hw_app/types";
import { getChainByTransport } from "./hw_app/chain";

import TransportU2F from "@ledgerhq/hw-transport-u2f";

export default {
  name: "App",
  mounted() {
    // request => {
    //   id: "xxxxxxxxxxxxxxx",
    //   action: "requestIdentity",
    //   blockchain: "eth"
    //   data: {}
    // };
    // response => {
    //   id: "xxxxxxxxxxxxxxx",
    //   error: "Unknow error", // 错误时返回字段
    //   data: {}
    // };
    window.onmessage = e => {
      if (!e || !e.data || !e.data.action) {
        return;
      }
      console.log("from extension => ", e.data);
      switch (e.data.action) {
        case ReqeustActions.REQUEST_IDENTITY:
          this.requestIdentity(e.data.id, e.data.blockchain, e.data.data);
          break;
        case ReqeustActions.REQUEST_SIGNATURE:
          this.requestSignature(e.data.id, e.data.blockchain, e.data.data);
          break;
        default:
          break;
      }
    };
  },
  methods: {
    responseMessage(id, data = {}) {
      window.parent.postMessage({ id, data }, "*");
    },
    errorMessage(id, error) {
      window.parent.postMessage({ id, error }, "*");
    },
    requestIdentity(id, blockchain, data) {
      TransportU2F.create()
        .then(transport => {
          const chain = getChainByTransport(blockchain, transport);
          if (!chain) {
            this.errorMessage(id, new Error("Invalid chain:" + blockchain));
          }
          chain
            .getAddress(data)
            .then(response => {
              this.responseMessage(id, response);
            })
            .catch(error => {
              this.errorMessage(id, error);
            });
        })
        .catch(error => {
          this.errorMessage(id, error);
        });
    },
    requestSignature(id, blockchain, data) {
      TransportU2F.create()
        .then(transport => {
          const chain = getChainByTransport(blockchain, transport);
          if (!chain) {
            this.errorMessage(id, new Error("Invalid chain:" + blockchain));
          }
          chain
            .signTransaction(data)
            .then(response => {
              this.responseMessage(id, response);
            })
            .catch(error => {
              this.errorMessage(id, error);
            });
        })
        .catch(error => {
          this.errorMessage(id, error);
        });
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
